<template>
	<div>
		<div>
			<CustomLoader v-if="isLoading" :width="70"></CustomLoader>
			<!-- <loading
				:active.sync="isLoading"
				loader="spinner"
				color="#36304a"
				:width="70"
			></loading> -->
		</div>
		<b-card class="mainCardBG">
			<b-card-text>
				<b-navbar
					class="formCard"
					style="border-radius: 5px !important; padding-left: 0px:height: auto !important;"
					toggleable="lg"
					type="dark"
					variant="primary"
				>
					<b-navbar-brand center>NEW REVERSE TALLY</b-navbar-brand>
				</b-navbar>

			<div v-if="visible">
				<b-card>
					<b-collapse v-model="visible" id="collapse-2">
						<b-row class="mt-2">
						<b-col md="3">
							<label for="dateRange">Date</label>
							<date-range-picker
							:opens="openRight"
							:always-show-calendars="showCal"
							v-model="Filter.dateRange"
							:startDate="startDate"
							:endDate="endDate"
							:locale-data="locale"
							@update="SearchFilter"
							>
							</date-range-picker>
						</b-col>
						<b-col md="3">
							<label>Vendor</label>
							<model-list-select
							class="ml-1"
							:list="$store.getters['commonDropdownMaster/getAllTallyVendorList']"
							id="branchFilter"
							v-model="Filter.vendor_nameFilter"
							option-value="label"
							option-text="label"
							placeholder="Select Vendor"
							@input="SearchFilter"
							:isDisabled="
									$sessionsStorage.get('designation') != 'Admin' &&
									$sessionsStorage.get('nameUser') != 'Bhavneesh'
									? true
									: false
							"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>Vendor GST</label>
							<model-list-select
							class="ml-1"
							:list="$store.getters['commonDropdownMaster/getAllTallyVendorGstList']"
							id="branchFilter"
							v-model="Filter.vendor_gstFilter"
							option-value="vendor_add_Gstin"
							option-text="vendor_add_Gstin"
							placeholder="Select Vendor GST"
							@input="SearchFilter"
							:isDisabled="
									$sessionsStorage.get('designation') != 'Admin' &&
									$sessionsStorage.get('nameUser') != 'Bhavneesh'
									? true
									: false
							"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label for="clientName">Client</label>
							<model-list-select
							:list="$store.getters['common/getAllClientList']"
							id="clientName"
							v-model="Filter.clientIdFilter"
							option-value="clientId"
							option-text="clientName"
							placeholder="Select Client Name"
							@input="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>POR</label>
							<model-list-select
							@input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
							@searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
							:list="$store.getters['common/getAllPORList']"
							v-model="Filter.PORFilter"
							option-value="pickupId"
							option-text="pickupLocation"
							placeholder="Select Place of Receipt"
							@update="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>POD</label>
							<model-list-select
							@input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
							@searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
							:list="$store.getters['common/getAllPODList']"
							v-model="Filter.PODFilter"
							option-value="pickupId"
							option-text="pickupLocation"
							placeholder="Select Port of Discharge"
							@update="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>Container Type</label>
							<model-list-select
							:list="$store.getters['common/getAllContainerTypeList']"
							v-model="Filter.containerTypeFilter"
							option-value="containerTypeId"
							option-text="containerType"
							placeholder="Select Container Type"
							@input="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>Shipping Line</label>
							<model-list-select
							:list="$store.getters['common/getAllShippingLineList']"
							v-model="Filter.SlineFilter"
							option-value="shippingId"
							option-text="shippingLine"
							placeholder="Select Shipping Line"
							@input="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>Air Line</label>
							<model-list-select
							:list="$store.getters['common/getAllAirLineList']"
							v-model="Filter.airLineFilter"
							option-value="airlineId"
							option-text="airlineName"
							placeholder="Select Air Line"
							@input="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>Expense No.</label>
							<b-form-input
							class="mt-2"
							:formatter="capitalizeAll"
							v-model="Filter.InvoiceNoFilter"
							placeholder="Expense Number"
							@input="SearchFilter"
							></b-form-input>
						</b-col>
						<b-col md="3">
							<label>Assignment No.</label>
							<b-form-input
							:formatter="capitalizeAll"
							class="mt-2"
							v-model="Filter.assignmentFilter"
							placeholder=" Assignment No."
							@input="SearchFilter"
							></b-form-input>
						</b-col>
						<b-col md="3">
							<label>Common Search.</label>
							<b-form-input
							class="mt-2"
							:formatter="capitalizeAll"
							v-model="Filter.CommonFilter"
							placeholder="Common BL/Container Search"
							@input="SearchFilter"
							></b-form-input>
						</b-col>
						<b-col md="3">
							<label>Expense Status</label>
							<model-list-select
							:list="invoiceStatusdataList"
							v-model="Filter.invstatusFilter"
							option-value="inv"
							class="mt-2"
							option-text="int"
							placeholder="Select Status"
							@input="SearchFilter"
							></model-list-select>
						</b-col>
						<b-col md="3">
							<label>Branch</label>
							<model-list-select
							class="ml-1"
							:list="$store.getters['common/getAllBranchList']"
							id="branchFilter"
							v-model="Filter.branchFilter"
							option-value="pickupId"
							option-text="pickupLocation"
							placeholder="All"
							@input="SearchFilter"
							:isDisabled="
									$sessionsStorage.get('designation') != 'Admin' &&
									$sessionsStorage.get('nameUser') != 'Bhavneesh'
									? true
									: false
							"
							></model-list-select>
						</b-col>
						</b-row>

						<b-col md="3" class="mt-2 pull-right">
							<b-button
								size="sm"
								style="font-size: 0.675rem margin-left: auto"
								class="ml-1 pull-right"
								@click="clearFilter"
								variant="danger"
							> Reset & Close
							</b-button>
						</b-col>
					</b-collapse>
				</b-card>
			</div>

				<div class="box">
					<b-col md="12">
						<b-navbar toggleable="lg" type="dark" variant="info">
							<b-navbar-nav class="ml-auto">
								<b-nav-form>
									<b-button-group size="sm" class="m2-1 text-right">
									<b-button
										style="font-size: 0.675rem"
										:variant="
										Filter.dateRange.startDate ||
										Filter.dateRange.endDate ||
										Filter.vendor_nameFilter ||
										Filter.vendor_gstFilter ||
										Filter.clientIdFilter ||
										Filter.PORFilter ||
										Filter.PODFilter ||
										Filter.containerTypeFilter ||
										Filter.SlineFilter ||
										Filter.airLineFilter ||
										Filter.InvoiceNoFilter ||
										Filter.assignmentFilter ||
										Filter.CommonFilter ||
										// Filter.invstatusFilter ||
										Filter.branchFilter 
											? 'danger'
											: 'primary'
										"
										:class="'ml-4' + visible ? null : 'collapsed'"
										:aria-expanded="visible ? 'true' : 'false'"
										aria-controls="collapse-4"
										@click="visible = !visible"
									>
										{{
										Filter.dateRange.startDate ||
										Filter.dateRange.endDate ||
										Filter.vendor_nameFilter ||
										Filter.vendor_gstFilter ||
										Filter.clientIdFilter ||
										Filter.PORFilter ||
										Filter.PODFilter ||
										Filter.containerTypeFilter ||
										Filter.SlineFilter ||
										Filter.airLineFilter ||
										Filter.InvoiceNoFilter ||
										Filter.assignmentFilter ||
										Filter.CommonFilter ||
										// Filter.invstatusFilter ||
										Filter.branchFilter 
											? "Filter ON"
											: "Filter OFF"
										}}
									</b-button>

									<b-button class="mr-2" variant="secondary" @click="goBack">Back</b-button>
									</b-button-group>
								</b-nav-form>
							</b-navbar-nav>
						</b-navbar>
					</b-col>

					<div class="gutr">
						<b-button
							class="pull-left mb-1"
							v-if="rerverseTallyList.length > 0"
							:disabled="ExcelBtnName != 'Export As Excel' ? true : false"
							@click="getReports('Expense_BILLING', 'Export As Excel')"
							size="sm"
							variant="warning"
						>
							{{ ExcelBtnName }}
							<b-spinner
								v-if="ExcelBtnName != 'Export As Excel'"
								small
								label="Small Spinner"
							></b-spinner>
						</b-button>

						<h5 class="text-muted pull-right mt-2">
							<small v-if="isLoading == false">{{ totalRows }} Entries</small>
						</h5>
					</div>

					<div class="table-responsive tableMain gutr">
						<b-table
							show-empty
							stacked="md"
							:items="rerverseTallyList"
							responsive
							:fields="expenseFields"
							primary-key="tally_bill_exp_id"
							:per-page="pagination.perPage"
							:current-page="pagination.currentPage"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
							:sort-direction="sortDirection"
							class="position-relative"
						>
							<template slot="tally_bill_exp_id" slot-scope="row0">
								<span>{{
									row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
								}}</span>
							</template>
							<template slot="vendorName" slot-scope="row1">
								<span>Name : {{ row1.item.vendorName }}<br /></span>
								<span>GST : {{ row1.item.vendorGST }}<br /></span>
								<span>Add : {{ row1.item.vendorAdd }}<br /></span>
								<span>State : {{ row1.item.vendorState }}<br /></span>
								<span>GST Code : {{ row1.item.vendorStateCode }}</span>
							</template>
							<template slot="buyerName" slot-scope="row2">
								<span>Name : {{ row2.item.buyerName }}<br /></span>
								<span>GST : {{ row2.item.buyerGST }}<br /></span>
								<span>Add : {{ row2.item.buyerAdd }}<br /></span>
								<span>State : {{ row2.item.buyerState }}<br /></span>
								<span>GST Code : {{ row2.item.buyerStateCode }}</span>
							</template>
							<template slot="fk_all_module_id" slot-scope="row3">
								<span>Ass.No : {{ row3.item.AssNo }}<br /></span>
								<span>Ass.Date : {{ row3.item.AssDate }}<br /></span>
								<span>Raised From : {{ row3.item.RasiedFrom }}<br /></span>
								<span>Raised By : {{ row3.item.RaisedBy }}<br /></span>
							</template>
							<template slot="destination" slot-scope="row4">
								<span>POR : {{ row4.item.POR }}<br /></span>
								<span>POL : {{ row4.item.POL }}<br /></span>
								<span>POD : {{ row4.item.POD }}<br /></span>
								<span>FPOD : {{ row4.item.FPOD }}<br /></span>
								<span>Client : {{ row4.item.clientName }}<br /></span>
								<span>Sline : {{ row4.item.shippingLine }}<br /></span>
								<span>MBLNO : {{ row4.item.MBLNO }}<br /></span>
								<span>HBLNO : {{ row4.item.HBLNO }}<br /></span>
								<span>SOB : {{ row4.item.SOB }}<br /></span>
								<span>Vessel : {{ row4.item.vessel_voyage }}</span>
							</template>
							<template slot="status" slot-scope="row5">
								<span
									v-if="row5.item.ManualStatus != '' && row5.item.ManualStatus != null"
								>
									Manual Status :
									<span
										v-if="row5.item.ManualStatus == 'Active'"
										:style="row5.item.ManualStatus ? 'color: green' : 'color: red'"
										>{{ row5.item.ManualStatus }}</span
									> </span
								><br />
								<span v-if="row5.item.status != '' && row5.item.status != null">
									Expense Status :
									<span
										v-if="row5.item.status == 'Active'"
										:style="row5.item.status ? 'color: green' : 'color: red'"
										>{{ row5.item.status }}</span
									> </span
								><br />
							</template>

							<template slot="docDtls_No" slot-scope="row6">
								<span
									>Exp No :
									<b-button
										@click="goExpenseDet(row6.item)"
										variant="outline-info"
										size="xs"
										style="font-size: 0.675rem"
										class="mt-1"
										>{{ row6.item.docDtls_No }}</b-button
									><br
								/></span>
								<span>Exp Type : {{ row6.item.docDtls_Typ }}<br /></span>
								<span>Exp Date : {{ row6.item.Exp_Date }}<br /></span>
								<span>Container : {{ row6.item.ExpContainersNo }}<br /></span>
								<span>System Container : <br /></span>
								<div class="text-left" v-if="row6.item.AssContainerNos">
									<div v-if="row6.item.AssContainerNos">
										<span
											v-for="(item1, index) in row6.item.AssContainerNos.split(',')"
											:key="index"
										>
											<h6>
												<b-badge variant="light"
													>{{ item1 == "" ? "-------" : item1 }}
												</b-badge>
											</h6>
										</span>
									</div>
								</div>
								<div class="text-left" v-else>
									<b-badge variant="light">-------</b-badge>
								</div>
								<!-- <span>System Container : {{ row6.item.AssContainerNos }}<br /></span> -->
								<span>System Container Type : {{ row6.item.containerType }}<br /></span>
								<span>Updated Date : {{ row6.item.ExpUpdateDate }}<br /></span>

								<b-button
									class="mt-2"
									style="font-size: 0.675rem"
									size="sm"
									@click="showDocModal(row6.item)"
									variant="outline-info"
									>Summary & Documents</b-button
								>
								<br />
								<Assignment-Summary
									:title="'Shipment Summary Tracking - '"
									:fk_all_module_id="row6.item.fk_all_module_id"
									:jb_series="row6.item.ExpjobNo"
								/>
							</template>
						</b-table>
					</div>
				</div>

				<div>
					<b-modal
						class="modal-dialog-doc"
						size="xl"
						no-close-on-esc
						no-close-on-backdrop
						ref="doc-modal"
						hide-footer
						title=""
					>
						<div v-if="ALLMODULE">
							<doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
						</div>
						<b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
							>Close
						</b-button>
					</b-modal>
				</div>
				<div>
					<b-pagination
						limit="8"
						align="center"
						v-model="pagination.currentPage"
						:per-page="pagination.perPage"
						:total-rows="totalRows"
						@change="onPageChange($event)"
					></b-pagination>
				</div>
			</b-card-text>
		</b-card>

		<md-dialog-confirm
			:md-content-html="alert.content"
			:md-ok-text="alert.ok"
			ref="addPop"
		></md-dialog-confirm>
	</div>
</template>
  
<script>
  import axios from "axios";
  import moment from "moment";
  import DatePicker from "vue2-datepicker";
  import { ModelListSelect } from "vue-search-select";
//   import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
  import "vue-loading-overlay/dist/vue-loading.css";
  import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
  import { DateFormat, selectDateFormat, wordWrap } from "../../../helper/filters";
  import { globalPermissionStatus, lastVisitPage } from "../../../helper/collection";
  import DateRangePicker from "vue2-daterange-picker";
  import DocForm from "../../../component/allModuleForm/docLibrary.vue";
  import AssignmentSummary from "../../../component/common/assignmentSummary.vue";
  import CommonService from "../../../services/CommonService.js";
  
  import inputBox from "../../inputComponent/inputBox.vue";
  
  export default {
    beforeMount() {
      // this.containerTracking();
      let payload = {
        excelId: "PENDING_REVERSE_BILLING_COUNT",
      };
      this.$store.dispatch("common/setAllPendingReverseTallyList", JSON.stringify(payload));
      lastVisitPage(this.$router.history.current.fullPath);
      this.getCurrentLastDate();
      let payload_curr = {
        Currency: "Currency_DropDown",
      };
      this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload_curr));
      this.$store.dispatch(
        "commonDropdownMaster/setAllTallyVendorDDList",
        JSON.stringify({
          itemCode: "All_Vendor_List",
          Filter: { statusFilter: "1" },
          type: "Normal",
        })
      );
      this.$store.dispatch(
        "commonDropdownMaster/setAllTallyVendorGstDDList",
        JSON.stringify({
          itemCode: "All_Vendor_GST_List",
          Filter: { statusFilter: "1" },
          type: "Normal",
        })
      );
      this.$store.dispatch("common/setAllAgentColoaderList");
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
  
      this.$store.dispatch("common/setAllAgentColoaderList");
  
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList",
        })
      );
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
  
      this.$store.dispatch(
        "common/setAllAirLineList",
        JSON.stringify({
          itemCode: "AirLineList",
        })
      );
  
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({
          itemCode: "LocationDetailsFinalList",
        })
      );
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({
          itemCode: "PORList",
        })
      );
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
		   type:'Normal',
        Territory:'',
        })
      );
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({
          itemCode: "POLList",
        })
      );
  
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      );
      if (globalPermissionStatus("Accounts")) {
        this.$store.dispatch("setCurrentRoute", "/viewBillingDetails/viewBillingDetails");
        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.fetchLastPage(this.lastVisitPage);
        } else {
          this.getAllExpenseList("Normal");
        }
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    },
  
    data() {
      return {
        rerverseTallyList: [],
				filter: null,
        Filter: {
          InvoiceNoFilter: "",
          clientIdFilter: "",
          assignmentFilter: "",
          CommonFilter: "",
          ContainerNoFilter: "",
          containerTypeFilter: "",
          InvoiceTypeFilter: "",
          BLNOFilter: "",
          ShipperINVFilter: "",
          ShippingBillLNOFilter: "",
          SlineFilter: "",
          airLineFilter: "",
          branchFilter: "",
          ClientFilter: "",
          PORFilter: "",
          POLFilter: "",
          PODFilter: "",
          FPODFilter: "",
          invstatusFilter: "1",
          // dateTypeFilter:"Expense",
  
          pridel_nameFilter: "",
          pridel_gstFilter: "",
          pridel_addressFilter: "",
          pridel_stateFilter: "",
          vendor_nameFilter: "",
          vendor_gstFilter: "",
          vendor_addressFilter: "",
          vendor_stateFilter: "",
          dateRange: { startDate: "", endDate: "" },
        },
        visible: false,
        docURL: URL_BASE_DOC,
        ALLMODULE: "",
        JOBSERIES: "",
        lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
  
        startDate: "2017-09-05",
        endDate: "2017-09-15",
        openRight: "right",
        showCal: false,
        showDash: false,
  
        locale: {
          direction: "ltr",
          format: "mm/dd/yyyy",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          firstDay: 0,
        },
        totalRows: 0,
        pagination: {
          currentPage: 1,
          perPage: 25,
          pageOptions: [5, 10, 15],
        },
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
  
        expenseFields: [
          {
            key: "tally_bill_exp_id",
            mainkey: "tally_bill_exp_id",
            label: "SN",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "docDtls_No",
            mainkey: "docDtls_No",
            label: "Expense Det.",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "vendorName",
            mainkey: "vendorName",
            label: "Vendor",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "buyerName",
            mainkey: "buyerName",
            label: "Buyers",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "fk_all_module_id",
            mainkey: "fk_all_module_id",
            label: "Assignment",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "destination",
            mainkey: "destination",
            label: "Locations",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "TotInvVal",
            mainkey: "TotInvVal",
            label: "Amt",
            sortable: true,
            sortDirection: "ASC",
          },
          {
            key: "status",
            mainkey: "status",
            label: "Status",
            sortable: true,
            sortDirection: "ASC",
          },
        ],
  
        isLoading: false,
        ExcelBtnName: "Export As Excel",
        alert: {
          content: "Are you sure you want to delete ..!",
          ok: "ok",
        },
  
        jobList: [
          {
            jv: "FF",
            jt: "FF",
          },
          {
            jv: "CC",
            jt: "CC",
          },
          {
            jv: "TPT",
            jt: "TPT",
          },
        ],
        invoiceStatusdataList: [
          {
            inv: "0",
            int: "All",
          },
          {
            inv: "1",
            int: "Active",
          },
          {
            inv: "2",
            int: "In-Active",
          },
        ],
        dateStatusdataList: [
          {
            inv: "Expense",
            int: "Expense",
          },
          {
            inv: "Assignment",
            int: "Assignment",
          },
        ],
      };
    },
  
    mounted() {
      document.title = "Pridel | " + this.$route.name;
      console.log(this.$route.name);
      console.log(this.$route.path);
      console.log(this.$route.params);
      console.log(this.$route.query);
    },
    filters: {
      moment(date) {
        return DateFormat(date);
      },
    },
  
    beforeDestroy() {},
  
    destroyed() {},
  
    components: {
		//   Loading,
	 CustomLoader,
      DatePicker,
      ModelListSelect,
      DateRangePicker,
      DocForm,
      AssignmentSummary,
      inputBox,
    },
  
    computed: {},
    watch: {
			JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getAllExpenseList("Normal");
      },
      deep: true,
    },
		},
    methods: {
      showDocModal(item) {
        console.log("Summary & Docs => ", item);
        this.ALLMODULE = "";
        this.JOBSERIES = "";
        this.ALLMODULE = item.fk_all_module_id;
        this.JOBSERIES = item.ExpjobNo;
        console.log(this.ALLMODULE);
        this.$refs["doc-modal"].show();
      },
      hideDocModal() {
        this.$refs["doc-modal"].hide();
      },
      gotoDocs(item) {
        this.$router.push({
          path: "/allModule/docs/" + item,
        });
      },
      goBack() {
        window.history.go(-1);
      },
      goExpenseDet(item) {
        this.$sessionsStorage.set("tallyExpenseId", "");
        this.$sessionsStorage.set("tallyExpenseallModuleID", "");
        this.$sessionsStorage.set("tallyExpenseId", item.tally_bill_exp_id);
        this.$sessionsStorage.set("tallyExpenseallModuleID", item.fk_all_module_id);
        this.$router.push({
          path: "/tallyExpDetails",
        });
      },
      getCurrentLastDate() {
        var today = new Date();
        var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        // alert(firstDay);
        // alert(lastDay);
  
        var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
        var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
        var firstDay_yyyy = firstDay.getFullYear();
  
        var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
        var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
        var lastDay_yyyy = lastDay.getFullYear();
  
        firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
        lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
  
        let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
        let newdate = firstYear + "-04-01";
        firstDay = new Date(newdate);
  
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + "/" + mm + "/" + dd; //2018-06-01
        this.startDate = today;
        this.dateRange = {
          startDate: firstDay,
          endDate: lastDay,
        };
        // alert(today);
      },
      getReports(id, btnName) {
        this.ExcelBtnName = "Downloading Please Wait .....";
        this.getAllExpenseList("Excell");
      },

			clearFilter() {
				this.visible = false,
				this.rerverseTallyList = [];
				this.Filter = {
					InvoiceNoFilter: "",
					assignmentFilter: "",
					CommonFilter: "",
					ContainerNoFilter: "",
					containerTypeFilter: "",
					InvoiceTypeFilter: "",
					BLNOFilter: "",
					ShipperINVFilter: "",
					ShippingBillLNOFilter: "",

					clientIdFilter: "",
					SlineFilter: "",
					airLineFilter: "",
					branchFilter: "",
					ClientFilter: "",
					PORFilter: "",
					POLFilter: "",
					PODFilter: "",
					FPODFilter: "",
					invstatusFilter: "1",

					dateRange: {
						startDate: "",
						endDate: "",
					},
					startDate: "",
					endDate: "",
				};
				this.dateRange = {
					startDate: "",
					endDate: "",
				};
				this.getCurrentLastDate();
				this.getAllExpenseList("Normal");
			},

      getAllExpenseList(type) {
        this.rerverseTallyList = [];
				this.totalRows = 0;
				this.isLoading = true;
				let payload = {
					itemCode: "New_Rerverse_Tally_List",
					Filter: this.Filter,
					type: type,
				};
				CommonService.getAllExpenseList(payload)
					.then((response) => {
						const { data, status, statusText } = response;
						if (status == 200 && data) {
							if (type == "Excell") {
								this.ExcelBtnName = "Export As Excel";
								if (data.rerverseTallyList.length > 0) {
									this.rerverseTallyList = data.rerverseTallyList;
									this.totalRows = data.rerverseTallyList.length;
								}
								window.location.href =
									`https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
							} else {
								if (data.rerverseTallyList.length > 0) {
									this.rerverseTallyList = data.rerverseTallyList;
									this.totalRows = data.rerverseTallyList.length;
									console.log(" getAllExpenseList response=>", data);
								}
							}
						} else {
							this.rerverseTallyList = [];
						}
						this.isLoading = false;
						this.PaginationCount = this.pagination.perPage;
					})
					.catch((error) => {
						console.log("Catch on getAllExpenseList Error: ", error);
					});
      },
      SearchFilter(event) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.getAllExpenseList("Normal");
        }, 1000);
      },
      pagechangeData() {
        this.pagination.perPage = this.PaginationCount;
        this.getAllExpenseList("Normal");
      },
      wordWrap,
      fetchLastPage(event) {
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
        }
        this.getAllExpenseList("Normal");
      },
      onPageChange: function (event) {
        this.$sessionsStorage.set("lastVisitPage", event);
        this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = event * this.pagination.perPage - this.pagination.perPage;
        }
        this.getAllExpenseList("Normal");
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.pagination.currentPage = 1;
      },
      viewExportFCLConPage(AM) {
        this.$sessionsStorage.set("editSalesExId", AM);
  
        this.$router.push({
          path: "/mainEnquiry/salesExecutionAll",
        });
      },
    },
  };
</script>

<style></style>
  


// WEBPACK FOOTER //
// newReverseTally.vue?3243a260